import { Component, Input } from '@angular/core';
import { DeleteConfirmModalComponent } from 'src/app/components/modal/delete-confirm-modal/delete-confirm-modal.component';
import { ModalService } from 'src/app/components/modal/modal.service';
import { BundlesService } from 'src/app/pages/bundles/bundles.service';
import { BundlesModalComponent } from 'src/app/components/modal/bundles-modal/bundles-modal.component';

@Component({
    selector: 'app-ta-type-bundle-list',
    templateUrl: './ta-type-bundle-list.component.html',
    styleUrls: ['./ta-type-bundle-list.component.scss'],
})
export class TaTypeBundleListComponent {
    @Input() callbackData: any;
    constructor(private modal: ModalService, bundlesService: BundlesService) {}

    ngOnInit() {
        console.log('CALL BACK DATA BUNDLE DELETE', this.callbackData);
    }

    deleteBtnAction() {
        console.log('deleteBtnAction', this.callbackData);
        if (this.callbackData) {
            this.callbackData[0].callback(this.callbackData[0].arg[0], this.callbackData[0].arg[1]);
        }
    }
}
